import React from "react";
import { Tooltip } from "antd";

// CU-14ygtkj8nr3: moved out of Sidebar.tsx so the Customer shell docks the same leaf, tooltip included; keyboard-operable since review.
const NavItem: React.FC<{
	navKey: string;
	label: string;
	icon: React.ReactNode;
	isActive: boolean;
	collapsed: boolean;
	onClick: () => void;
	/** Count pill on the trailing edge. See the absence rule below. */
	badge?: number;
	testId?: string;
	cta?: boolean;
}> = ({ navKey, label, icon, isActive, collapsed, onClick, badge, testId, cta }) => {
	const showBadge = typeof badge === "number" && badge > 0;
	// CU-14ygtkj8nr3: Space would otherwise scroll the rail, so both keys activate on keydown with the default suppressed.
	const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
		if (e.key !== "Enter" && e.key !== " ") return;
		e.preventDefault();
		onClick();
	};
	const el = (
		<div className={`mg-nav-item${isActive ? " active" : ""}${cta ? " mg-nav-item-cta" : ""}`} onClick={onClick} onKeyDown={onKeyDown} tabIndex={0} role="menuitem" data-testid={testId}>
			<span className="mg-nav-item-icon">{icon}</span>
			<span className="mg-nav-item-label">{label}</span>
			{showBadge && <span className="mg-nav-item-badge">{badge}</span>}
		</div>
	);
	if (collapsed) {
		return (
			<Tooltip title={showBadge ? `${label} · ${badge}` : label} placement="right" trigger={["hover", "focus"]}>
				{el}
			</Tooltip>
		);
	}
	return el;
};

export default NavItem;
